module.exports = {"id":"219740","name":"Kahraba","rating":"75","photo":"./data/images/photos/2/219740.png","club":{"name":"Al Ittihad","logo":"./data/images/clubs/AlIttihad.png"},"positions":["MG","MD","AG","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Kahraba0.json
// module id = 2273
// module chunks = 0